import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toProgressPercentage',
    standalone: true
})
export class ToProgressPercentagePipe implements PipeTransform {

  transform(value: number, ...args: number[]): number {
    const loaded = value;
    const total = args[0];

    return Math.round(loaded / total * 100);
  }

}
